import { MenuConfigItem } from 'components/common/SideMenu/SideMenu';

type SettingsConfigKey =
    | 'userProfile'
    | 'userManagement'
    | 'userManagementNewUser'
    | 'userManagementEditUser'
    | 'userGroups'
    | 'userGroupsNew'
    | 'userGroupsEdit'
    | 'roleManagement'
    | 'roleManagementNewRole'
    | 'roleManagementEditRole'
    | 'tags'
    | 'tagsNew'
    | 'tagsEdit'
    | 'narrativeTemplates'
    | 'customerProfile'
    | 'integrations'
    | 'opc'
    | 'createOpc'
    | 'editOpc'
    | 'viewOpc';

export const settingsConfig: Record<SettingsConfigKey, MenuConfigItem> = {
    userProfile: {
        name: 'My User Profile',
        link: 'user-profile',
        title: 'My User Profile',
        tooltip: 'Amend user profile details',
    },
    userManagement: {
        name: 'User Management',
        link: 'user-management',
        title: 'User Management',
        tooltip: 'Add, edit, or remove users',
    },
    userManagementNewUser: {
        name: '',
        link: 'new-user',
        title: 'User Management',
    },
    userManagementEditUser: {
        name: 'User Management',
        link: 'edit-user',
        title: 'User Management',
    },
    userGroups: {
        name: 'User Groups',
        link: 'user-groups',
        title: 'User Groups Management',
        tooltip: 'Create or manage User Groups to configure access to Roles and Projects',
    },
    userGroupsNew: {
        name: '',
        link: 'new',
        title: 'User Groups Management',
    },
    userGroupsEdit: {
        name: '',
        link: 'edit',
        title: 'User Groups Management',
    },
    roleManagement: {
        name: 'Roles Management',
        link: 'role-management',
        title: 'Role Management',
        tooltip: 'Create or manage User Roles to configure access to specific areas of the platform',
    },
    roleManagementNewRole: {
        name: '',
        link: 'new-role',
        title: 'Role Management',
    },
    roleManagementEditRole: {
        name: '',
        link: 'edit',
        title: 'Role Management',
    },
    tags: {
        name: 'Tags',
        link: 'tags',
        title: 'Tags Management',
        tooltip: 'Create or manage Tags',
    },
    tagsNew: {
        name: '',
        link: 'new',
        title: 'Tags Management',
    },
    tagsEdit: {
        name: '',
        link: 'edit',
        title: 'Tags Management',
    },
    narrativeTemplates: {
        name: 'Narrative Templates',
        link: 'narrative-templates',
        title: 'Narrative Templates',
    },
    customerProfile: {
        name: 'Customer Profile',
        link: 'customer-profile',
        title: 'Customer Profile',
    },
    integrations: {
        name: 'Integrations',
        link: 'integrations',
        title: 'Integrations',
    },
    opc: {
        name: 'OPC',
        link: 'opc',
        title: 'OPC',
    },
    createOpc: {
        name: 'Create OPC',
        link: 'create',
        title: 'Create OPC',
    },
    viewOpc: {
        name: 'View OPC',
        link: 'view',
        title: 'View OPC',
    },
    editOpc: {
        name: 'Edit OPC',
        link: 'edit',
        title: 'Edit OPC',
    },
};
